import { render, staticRenderFns } from "./StaffDeviceQRCode.vue?vue&type=template&id=22985470&scoped=true"
import script from "./StaffDeviceQRCode.vue?vue&type=script&lang=js"
export * from "./StaffDeviceQRCode.vue?vue&type=script&lang=js"
import style0 from "./StaffDeviceQRCode.scss?vue&type=style&index=0&id=22985470&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22985470",
  null
  
)

export default component.exports